import get from 'lodash.get';
import status from 'src/js/modules/status';
import statusNames from '../constants/status-names';

const getAvailablePackagesStatus = (rootState) =>
  get(status.selectors.getStatus(rootState), statusNames.AVAILABLE_PACKAGES);

export default getAvailablePackagesStatus;
